import Plain from "./Plain";
export function Projects() {
  return (
    <div style={{display:"flex",flexDirection:"row",flexWrap:"wrap",justifyContent:"space-between",gap:"2rem"}}>
      <Plain link="https://poetic-pixie-436110.netlify.app/" img="/pic.png">
        <h2>Popcorn</h2>
        <p>Movie search web application</p>
      </Plain>
      <Plain link="https://type-ochi.netlify.app/" img="/ochi.png">
        <h2>Ochi Design</h2>
        <p>Ochi design website clone</p>
      </Plain>
      <Plain link="https://builds-social.netlify.app/" img="/builds.png">
        <h2>Builds</h2>
        <p>Social media web application</p>
      </Plain>
    </div>
  );
}
